import contributorRoles from "../../src/api/articles/constants/contributorRoles";

import createCover from "./createCover";
import createDocumentIdAndRef from "./createDocumentIdAndRef";

export default async function createWork({ api, env }, { production, commonArticleData }) {
	const { id, ref } = createDocumentIdAndRef({ api, env }, { collection: "works" });
	const { contributors, ...restArticleData } = commonArticleData;
	const withoutNarrators =
		contributors?.filter((contributor) => contributor.role !== contributorRoles.NARRATOR) || [];
	const work = {
		id,
		ref,
		name: production.title,
		synopsis: production.synopsis || production.deliveryEbook?.synopsis || "",
		contributors: withoutNarrators,
		...restArticleData,
	};
	const cover = await createCover({ api, env }, { img: production.img });
	const coverThumb = await createCover({ api, env }, { img: production.imgThumb });

	return {
		...work,
		cover,
		coverThumb,
	};
}
